import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  menuItems = [
    { label: 'Home', route: '/' },
    { label: 'About Us', route: '/about' },
    { label: 'Projects', route: '/projects' },
    { label: 'Services', route: '/services' },
    { label: 'Contact', route: '/contact' },
  ];

  quickLinks = [
    { label: 'Privacy Policy', route: '/privacy-policy' },
    { label: 'Terms & Conditions', route: '/terms-conditions' },
    { label: 'Careers', route: '/careers' },
  ];

  socialLinks = [
    { icon: 'linkedin', url: 'https://linkedin.com', label: 'LinkedIn' },
    { icon: 'facebook', url: 'https://facebook.com', label: 'Facebook' },
    { icon: 'instagram', url: 'https://instagram.com', label: 'Instagram' },
    { icon: 'twitter', url: 'https://twitter.com', label: 'Twitter' },
  ];
}
